import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, ROLE_HOME } from "@/context/AuthContext";
import { Compass } from "lucide-react";

function FullLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-navy-900" data-testid="auth-loading">
      <Compass className="w-10 h-10 text-gold animate-spin" style={{ animationDuration: "3s" }} />
    </div>
  );
}

export function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading || user === null) return <FullLoader />;
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={ROLE_HOME[user.role] || "/app"} replace />;
  }
  return children;
}
